import type {
	AquacultureResponse,
	ModuleFull,
} from "../../../pages/activityBuilder/modules/aquaculture/aquacultureTypes";
import { apiSlice, publicApiSlice, TagTypes } from "../../apiSlice";
import {
	includedPropList,
	includedT2PropList,
} from "../../../pages/activityBuilder/modules/aquaculture/aquaculture";
import { FEModulesObj } from "../../../utils/moduleList";
import { FEModules } from "../../../utils/moduleList";
import { prepareModulePayload, transformModuleResponse } from "./factories/moduleApiUtils";
import { createModuleGetApi, createModuleUpdateApi } from "./factories/createModuleApi";

//Define constants for the module
const MODULE_TYPE = "Aquaculture";
const TAG: TagTypes = "Aquaculture";
const TAG_DEFAULTS: TagTypes = "AquacultureDefaults";
const ENDPOINT = FEModulesObj[FEModules.Aquaculture].path;

const transformResponse = (response: AquacultureResponse) => transformModuleResponse<AquacultureResponse, ModuleFull>({
	response,
	includedPropList,
	includedT2PropList,
})

const aquacultureApiSlice = createModuleGetApi<ModuleFull>({
	apiSlice,
	path: ENDPOINT,
	moduleName: MODULE_TYPE,
	tag: TAG,
	tagDefaults: TAG_DEFAULTS,
	transformResponse,
})

const publicAquacultureApiSlice = createModuleGetApi<ModuleFull>({
	apiSlice: publicApiSlice,
	path: ENDPOINT,
	moduleName: MODULE_TYPE,
	tag: TAG,
	tagDefaults: TAG_DEFAULTS,
	transformResponse,
})

export const {
	useGetAquacultureQuery,
	useGetAquacultureDefaultsQuery,
} = aquacultureApiSlice;

export const {
	useGetAquacultureQuery: usePublicGetAquacultureQuery,
	useGetAquacultureDefaultsQuery: usePublicGetAquacultureDefaultsQuery,
} = publicAquacultureApiSlice;

const transformUpdatePayload = (data: ModuleFull, activityId: number) => prepareModulePayload({
	moduleData: data.module,
	tiertwoData: data.tiertwo,
	activityId
})

const mutationApiSlice = createModuleUpdateApi<ModuleFull, AquacultureResponse>({
	apiSlice,
	path: ENDPOINT,
	moduleName: MODULE_TYPE,
	tag: TAG,
	tagDefaults: TAG_DEFAULTS,
	transformUpdatePayload,
})

export const {
	useUpdateAquacultureMutation,
} = mutationApiSlice;